import { createContext } from 'react';

export const DisplayDestinationMarkersContext = createContext(0);
